export default function downFile({url}) {
  const elink = document.createElement('a')
  elink.download = 'excel.xls'
  elink.style.display = 'none'
  elink.href = url;
  document.body.appendChild(elink)
  elink.click()
  document.body.removeChild(elink)
}